import './App.css';
import Header from './Header';
import About from './About';
import HomePage from './HomePage'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SafetyTraining from './SafetyTraining';
import Faq from './Faq';
import Pricing from './Pricing';
import LifeSaving from './Lifesaving';
import Login from './login';
import Cognito from './Cognito';
import Dashboard from './Dashboard';
import DrivingPro from './DrivingPro';

import { Authenticator, ThemeProvider } from '@aws-amplify/ui-react';
import ContactForm from './Form';
import CheckoutForm from './CheckoutForm';
import CheckoutPage from './ProductPage';
import BusinessPage from './BusinessPage';

import VRPurchasePage from './VRPurchasePage';
import Footer from './Footer';
import SuccessPage from './SuccessPayment';
import GamePlay from './PlayGame';
import GameVids from './GameVid';
import Fundamental from './Fundamentals';
import VRInstruction from './VRInstruction';
import ComingSoon from './ComingSoon';




function App() {



  return (
        <Authenticator.Provider>

    <Router>
<div className="App">
  <main>

    <Routes>
      <Route path="/" element={<> <Header/> <HomePage /> </>} />
      <Route path= "/life-saving" element = {<> <Header/> <LifeSaving /> </>}/>
      <Route path="/Pricing" element={<> <Header/> <Pricing /> </>} />
      <Route path="/SafetyTraining" element={<> <Header/>  <SafetyTraining/> </>} />
      <Route path="Driving-pro" element= {<><Header/> <DrivingPro/> </>}/>
      <Route path="/fundamentals" element={<><Header/> <Fundamental/></>} />
      <Route path="/faq" element={<> <Header/> <Faq /> </>}/>
      <Route path="/About" element={<> <Header/> <About /> </>}/>
      <Route path="/Login" element={ <> <Header/><Login />  </>}/>
      <Route path="/dashboard" element={<Dashboard />}/>
      <Route path="/Contact" element = {<><Header/><ContactForm /> </>} />
      <Route path="/checkout" element = {<><Header/><CheckoutForm/></>}/>
      <Route path="/success" element={<><Header/> <SuccessPage/></>} />
      <Route path="/gamePlay" element={<><Header/> <GamePlay/></>} />
      <Route path="/module-videos" element={<><Header/> <GameVids/></>} />
      <Route path="/installation_guide" element={<><Header/> <VRInstruction/></> }/>
      <Route path="/pclicense" element={<><Header/> <CheckoutPage/></>} />
      {/* <Route path="/vrlicense" element={<><Header/> <VRPurchasePage/></>} /> */}
      <Route path="/comingsoon" element={<><Header/> <ComingSoon/></>} />

     


    

    </Routes>




    <Footer />
</main>
    </div>
    </Router>

        </Authenticator.Provider>

  );
}

export default App;
